var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("VirtualCollection", {
    attrs: {
      cellSizeAndPositionGetter: _vm.cellSizeAndPositionGetter,
      collection: _vm.collectionItems,
      height: _vm.height,
      width: _vm.width,
    },
    scopedSlots: _vm._u([
      {
        key: "cell",
        fn: function (props) {
          return [
            _c(
              "v-list-tile",
              {
                on: {
                  click: function ($event) {
                    return _vm.toggle(props.data)
                  },
                },
              },
              [
                _c(
                  "v-list-tile-title",
                  [
                    _c(
                      "v-layout",
                      [
                        _c(
                          "v-flex",
                          { staticClass: "done-icon pr-1" },
                          [
                            _c(
                              "v-icon",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.items[props.data],
                                    expression: "items[props.data]",
                                  },
                                ],
                              },
                              [_vm._v("done")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-flex", [_vm._v(_vm._s(props.data))]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }